import { Text } from 'components/Text'
import { styled } from 'stitches.config'

export const HeroSection = styled('section', {
  backgroundColor: '$secondary-500',
  width: '100%',
})

export const HeroContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '500px',
  maxWidth: '2400px',
  margin: 'auto',
  '@bp2': {
    flexDirection: 'row',
  },
})

export const HeroImageWrapper = styled('div', {
  position: 'relative',
  width: '100%', aspectRatio: '1.86',

  '@bp2': {
    flexBasis: '50%',
   
  },
  '& img': {
    objectFit: 'cover',
  },
})

export const HeroCopyColumn = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$secondary-500',
  color: '$accent-white',
  padding: '$7 $2',
  textAlign: 'center',
  '@bp2': {
    flexBasis: '50%',
    padding: '$5',
  },
  '@bp3': {
    padding: '$3',
  },
  '@bp4': {
    padding: '$10',
  },
})

export const CopyInner = styled('div', {
  width: '100%',
  maxWidth: '720px',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$2',
})

export const HeroHeading = styled('h1', {
  marginTop: '0',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  width: '100%',
  maxWidth: '',
  '@bp3': {
    maxWidth: '100%',
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
})

export const HeroParagraph = styled(Text, {
  width: '100%',
  maxWidth: '470px',
})
